import { render, staticRenderFns } from "./Liushui.vue?vue&type=template&id=6d4fa6fa&scoped=true"
import script from "./Liushui.vue?vue&type=script&lang=js"
export * from "./Liushui.vue?vue&type=script&lang=js"
import style0 from "./Liushui.vue?vue&type=style&index=0&id=6d4fa6fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4fa6fa",
  null
  
)

export default component.exports